




































import RatioContainer from '@sbvr/component-helpers/RatioContainer.vue';
import ClickArea from '@sbvr/component-helpers/ClickArea.vue';
import LazyImg from '@sbvr/component-helpers/LazyImg.vue';
import { createComponent } from '@vue/composition-api';

export default createComponent({
  name: 'UICard',
  components: {
    RatioContainer,
    ClickArea,
    LazyImg,
  },
  props: {
    title: {},
    instructions: {},
    link: {},
    imageUrl: {},
    imageSrcSet: {},
    imagePlaceholder: {},
    badges: {
      type: Array as () => { text: string; class: string }[],
      default: () => ([]),
    },
  },
});
